import * as React from 'react'

const Footer = () => {
  return (
    <footer className='DemoDetail__footer'>
      <div className='container'>
        <p>
          &copy;{new Date().getFullYear()} <strong>Data Wow Co., Ltd.</strong>{' '}
          All Rights Reserved.
        </p>

        <div className='DemoDetail__footer__space'></div>

        <nav>
          <a href='/policy' title='Privacy Policy'>
            Privacy Policy
          </a>
        </nav>
        <p>
          Made with <IconHeart /> in Bangkok
        </p>
      </div>
    </footer>
  )
}

const IconHeart = (props) => {
  return (
    <svg viewBox='0 0 24 24' fill='currentColor' {...props}>
      <path d='M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z' />
    </svg>
  )
}

export default Footer
